"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Asset extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.gateway = null;
        this.objectTypeName = 'asset';
        this._widgetBoardId = initParams.widget_board_id;
        this._lastContacted = initParams.last_contacted;
        this._nbIotEcl = initParams.nb_iot_ecl;
        this._groupIds = (0, util_1.camelArray)(initParams.group_ids);
        this._name = initParams.name;
        this._siteName = initParams.site_name;
        this._siteId = initParams.site_id;
        this._siteTimezone = initParams.site_timezone;
        this._impKwh = initParams.imp_kwh;
        this._parentAsset = initParams.parent_asset;
        this._currentState = initParams.current_state;
        this._userState = initParams.user_state;
        this._sku = initParams.sku;
        this._code = initParams.code;
        this._dataType = initParams.data_type;
        this._deviceCategory = initParams.device_category;
        this._deviceCategoryColor = initParams.device_category_color;
        this._deviceCategoryIcon = initParams.device_category_icon;
        this._generation = initParams.generation;
        this._assetIndex = initParams.asset_index;
        this._ble = initParams.ble;
        this._boostFinish = initParams.boost_finish;
        this._snoozeFinish = initParams.snooze_finish;
        this._loadType = initParams.load_type;
        this._gatewayId = initParams.gateway_id;
        this._gatewayName = initParams.gateway_name;
        this._applianceType = initParams.appliance_type;
        this.__permission = initParams._permission;
        this._serialNo = initParams.serial_no;
        this._readOnly = initParams.read_only;
        this._locked = initParams.locked;
        this._children = (0, util_1.camelArray)(initParams.children);
        this._disconnected = initParams.disconnected;
        this._gatewayDisconnected = initParams.gateway_disconnected;
        this._clampNameTwo = initParams.clamp_name_two;
        this._clampSize = initParams.clamp_size;
        this._climaxClamp = initParams.climax_clamp;
        this._triggerRules = (0, util_1.camelArray)(initParams.trigger_rules);
        this._alertRules = (0, util_1.camelArray)(initParams.alert_rules);
        this._advancedRules = (0, util_1.camelArray)(initParams.advanced_rules);
        this._consumption = initParams.consumption;
        this._consumptionPulse = initParams.consumption_pulse;
        this._gasPulse = initParams.gas_pulse;
        this._waterPulse = initParams.water_pulse;
        this._voc = initParams.voc;
        this._open = initParams.open;
        this._co2 = initParams.co2;
        this._pressure = initParams.pressure;
        this._waterPulseHot = initParams.water_pulse_hot;
        this._temperature = initParams.temperature;
        this._humidity = initParams.humidity;
        this._light = initParams.light;
        this._current = initParams.current;
        this._occupancy = initParams.occupancy;
        this._assetSignalStrength = initParams.asset_signal_strength;
        this._assetBatteryVoltage = initParams.asset_battery_voltage;
        this._assetBatteryAlarm = initParams.asset_battery_alarm;
        this._assetBatteryPercent = initParams.asset_battery_percent;
        this._firmwareTarget = initParams.firmware_target;
        this._assetFirmwareVersion = initParams.asset_firmware_version;
        this._assetFirmwareProgress = initParams.asset_firmware_progress;
        this._demandPhaseOne = initParams.demand_phase_one;
        this._demandPhaseTwo = initParams.demand_phase_two;
        this._demandPhaseThree = initParams.demand_phase_three;
        this._pfPhaseOne = initParams.pf_phase_one;
        this._pfPhaseTwo = initParams.pf_phase_two;
        this._pfPhaseThree = initParams.pf_phase_three;
        this._virtualLink = initParams.virtual_link;
        this._doReconfigure = initParams.do_reconfigure;
        this._modbusId = initParams.modbus_id;
        this._anomalyDetection = initParams.anomaly_detection;
        this._lowBattery = initParams.low_battery;
        this._lowSignal = initParams.low_signal;
        this._fault = initParams.fault;
        this._intermittent = initParams.intermittent;
        this._anomaly = initParams.anomaly;
        this._modbusDetails = initParams.modbus_details;
    }
    set widgetBoardId(value) {
        console.error('Do not set objects this way');
    }
    setWidgetBoardId(value) {
        return this.dataService.updateAsset(this.id, { widget_board_id: value }, this);
    }
    get widgetBoardId() {
        return this._widgetBoardId;
    }
    set lastContacted(value) {
        console.error('Do not set objects this way');
    }
    setLastContacted(value) {
        return this.dataService.updateAsset(this.id, { last_contacted: value }, this);
    }
    get lastContacted() {
        return this._lastContacted;
    }
    set nbIotEcl(value) {
        console.error('Do not set objects this way');
    }
    setNbIotEcl(value) {
        return this.dataService.updateAsset(this.id, { nb_iot_ecl: value }, this);
    }
    get nbIotEcl() {
        return this._nbIotEcl;
    }
    set groupIds(value) {
        console.error('Do not set objects this way');
    }
    setGroupIds(value) {
        return this.dataService.updateAsset(this.id, { group_ids: (0, util_1.snakeArray)(value) }, this);
    }
    get groupIds() {
        return this._groupIds;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateAsset(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    setSiteName(value) {
        return this.dataService.updateAsset(this.id, { site_name: value }, this);
    }
    get siteName() {
        return this._siteName;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    setSiteId(value) {
        return this.dataService.updateAsset(this.id, { site_id: value }, this);
    }
    get siteId() {
        return this._siteId;
    }
    set siteTimezone(value) {
        console.error('Do not set objects this way');
    }
    setSiteTimezone(value) {
        return this.dataService.updateAsset(this.id, { site_timezone: value }, this);
    }
    get siteTimezone() {
        return this._siteTimezone;
    }
    set impKwh(value) {
        console.error('Do not set objects this way');
    }
    setImpKwh(value) {
        return this.dataService.updateAsset(this.id, { imp_kwh: value }, this);
    }
    get impKwh() {
        return this._impKwh;
    }
    set parentAsset(value) {
        console.error('Do not set objects this way');
    }
    setParentAsset(value) {
        return this.dataService.updateAsset(this.id, { parent_asset: value }, this);
    }
    get parentAsset() {
        return this._parentAsset;
    }
    set currentState(value) {
        console.error('Do not set objects this way');
    }
    setCurrentState(value) {
        return this.dataService.updateAsset(this.id, { current_state: value }, this);
    }
    get currentState() {
        return this._currentState;
    }
    set userState(value) {
        console.error('Do not set objects this way');
    }
    setUserState(value) {
        return this.dataService.updateAsset(this.id, { user_state: value }, this);
    }
    get userState() {
        return this._userState;
    }
    set sku(value) {
        console.error('Do not set objects this way');
    }
    setSku(value) {
        return this.dataService.updateAsset(this.id, { sku: value }, this);
    }
    get sku() {
        return this._sku;
    }
    set code(value) {
        console.error('Do not set objects this way');
    }
    setCode(value) {
        return this.dataService.updateAsset(this.id, { code: value }, this);
    }
    get code() {
        return this._code;
    }
    set dataType(value) {
        console.error('Do not set objects this way');
    }
    setDataType(value) {
        return this.dataService.updateAsset(this.id, { data_type: value }, this);
    }
    get dataType() {
        return this._dataType;
    }
    set deviceCategory(value) {
        console.error('Do not set objects this way');
    }
    setDeviceCategory(value) {
        return this.dataService.updateAsset(this.id, { device_category: value }, this);
    }
    get deviceCategory() {
        return this._deviceCategory;
    }
    set deviceCategoryColor(value) {
        console.error('Do not set objects this way');
    }
    setDeviceCategoryColor(value) {
        return this.dataService.updateAsset(this.id, { device_category_color: value }, this);
    }
    get deviceCategoryColor() {
        return this._deviceCategoryColor;
    }
    set deviceCategoryIcon(value) {
        console.error('Do not set objects this way');
    }
    setDeviceCategoryIcon(value) {
        return this.dataService.updateAsset(this.id, { device_category_icon: value }, this);
    }
    get deviceCategoryIcon() {
        return this._deviceCategoryIcon;
    }
    set generation(value) {
        console.error('Do not set objects this way');
    }
    setGeneration(value) {
        return this.dataService.updateAsset(this.id, { generation: value }, this);
    }
    get generation() {
        return this._generation;
    }
    set assetIndex(value) {
        console.error('Do not set objects this way');
    }
    setAssetIndex(value) {
        return this.dataService.updateAsset(this.id, { asset_index: value }, this);
    }
    get assetIndex() {
        return this._assetIndex;
    }
    set ble(value) {
        console.error('Do not set objects this way');
    }
    setBle(value) {
        return this.dataService.updateAsset(this.id, { ble: value }, this);
    }
    get ble() {
        return this._ble;
    }
    set boostFinish(value) {
        console.error('Do not set objects this way');
    }
    setBoostFinish(value) {
        return this.dataService.updateAsset(this.id, { boost_finish: value }, this);
    }
    get boostFinish() {
        return this._boostFinish;
    }
    set snoozeFinish(value) {
        console.error('Do not set objects this way');
    }
    setSnoozeFinish(value) {
        return this.dataService.updateAsset(this.id, { snooze_finish: value }, this);
    }
    get snoozeFinish() {
        return this._snoozeFinish;
    }
    set loadType(value) {
        console.error('Do not set objects this way');
    }
    setLoadType(value) {
        return this.dataService.updateAsset(this.id, { load_type: value }, this);
    }
    get loadType() {
        return this._loadType;
    }
    set gatewayId(value) {
        console.error('Do not set objects this way');
    }
    setGatewayId(value) {
        return this.dataService.updateAsset(this.id, { gateway_id: value }, this);
    }
    get gatewayId() {
        return this._gatewayId;
    }
    set gatewayName(value) {
        console.error('Do not set objects this way');
    }
    setGatewayName(value) {
        return this.dataService.updateAsset(this.id, { gateway_name: value }, this);
    }
    get gatewayName() {
        return this._gatewayName;
    }
    set applianceType(value) {
        console.error('Do not set objects this way');
    }
    setApplianceType(value) {
        return this.dataService.updateAsset(this.id, { appliance_type: value }, this);
    }
    get applianceType() {
        return this._applianceType;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateAsset(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set serialNo(value) {
        console.error('Do not set objects this way');
    }
    setSerialNo(value) {
        return this.dataService.updateAsset(this.id, { serial_no: value }, this);
    }
    get serialNo() {
        return this._serialNo;
    }
    set readOnly(value) {
        console.error('Do not set objects this way');
    }
    setReadOnly(value) {
        return this.dataService.updateAsset(this.id, { read_only: value }, this);
    }
    get readOnly() {
        return this._readOnly;
    }
    set locked(value) {
        console.error('Do not set objects this way');
    }
    setLocked(value) {
        return this.dataService.updateAsset(this.id, { locked: value }, this);
    }
    get locked() {
        return this._locked;
    }
    set children(value) {
        console.error('Do not set objects this way');
    }
    setChildren(value) {
        return this.dataService.updateAsset(this.id, { children: (0, util_1.snakeArray)(value) }, this);
    }
    get children() {
        return this._children;
    }
    set disconnected(value) {
        console.error('Do not set objects this way');
    }
    setDisconnected(value) {
        return this.dataService.updateAsset(this.id, { disconnected: value }, this);
    }
    get disconnected() {
        return this._disconnected;
    }
    set gatewayDisconnected(value) {
        console.error('Do not set objects this way');
    }
    setGatewayDisconnected(value) {
        return this.dataService.updateAsset(this.id, { gateway_disconnected: value }, this);
    }
    get gatewayDisconnected() {
        return this._gatewayDisconnected;
    }
    set clampNameTwo(value) {
        console.error('Do not set objects this way');
    }
    setClampNameTwo(value) {
        return this.dataService.updateAsset(this.id, { clamp_name_two: value }, this);
    }
    get clampNameTwo() {
        return this._clampNameTwo;
    }
    set clampSize(value) {
        console.error('Do not set objects this way');
    }
    setClampSize(value) {
        return this.dataService.updateAsset(this.id, { clamp_size: value }, this);
    }
    get clampSize() {
        return this._clampSize;
    }
    set climaxClamp(value) {
        console.error('Do not set objects this way');
    }
    setClimaxClamp(value) {
        return this.dataService.updateAsset(this.id, { climax_clamp: value }, this);
    }
    get climaxClamp() {
        return this._climaxClamp;
    }
    set triggerRules(value) {
        console.error('Do not set objects this way');
    }
    setTriggerRules(value) {
        return this.dataService.updateAsset(this.id, { trigger_rules: (0, util_1.snakeArray)(value) }, this);
    }
    get triggerRules() {
        return this._triggerRules;
    }
    set alertRules(value) {
        console.error('Do not set objects this way');
    }
    setAlertRules(value) {
        return this.dataService.updateAsset(this.id, { alert_rules: (0, util_1.snakeArray)(value) }, this);
    }
    get alertRules() {
        return this._alertRules;
    }
    set advancedRules(value) {
        console.error('Do not set objects this way');
    }
    setAdvancedRules(value) {
        return this.dataService.updateAsset(this.id, { advanced_rules: (0, util_1.snakeArray)(value) }, this);
    }
    get advancedRules() {
        return this._advancedRules;
    }
    set consumption(value) {
        console.error('Do not set objects this way');
    }
    setConsumption(value) {
        return this.dataService.updateAsset(this.id, { consumption: value }, this);
    }
    get consumption() {
        return this._consumption;
    }
    set consumptionPulse(value) {
        console.error('Do not set objects this way');
    }
    setConsumptionPulse(value) {
        return this.dataService.updateAsset(this.id, { consumption_pulse: value }, this);
    }
    get consumptionPulse() {
        return this._consumptionPulse;
    }
    set gasPulse(value) {
        console.error('Do not set objects this way');
    }
    setGasPulse(value) {
        return this.dataService.updateAsset(this.id, { gas_pulse: value }, this);
    }
    get gasPulse() {
        return this._gasPulse;
    }
    set waterPulse(value) {
        console.error('Do not set objects this way');
    }
    setWaterPulse(value) {
        return this.dataService.updateAsset(this.id, { water_pulse: value }, this);
    }
    get waterPulse() {
        return this._waterPulse;
    }
    set voc(value) {
        console.error('Do not set objects this way');
    }
    setVoc(value) {
        return this.dataService.updateAsset(this.id, { voc: value }, this);
    }
    get voc() {
        return this._voc;
    }
    set open(value) {
        console.error('Do not set objects this way');
    }
    setOpen(value) {
        return this.dataService.updateAsset(this.id, { open: value }, this);
    }
    get open() {
        return this._open;
    }
    set co2(value) {
        console.error('Do not set objects this way');
    }
    setCo2(value) {
        return this.dataService.updateAsset(this.id, { co2: value }, this);
    }
    get co2() {
        return this._co2;
    }
    set pressure(value) {
        console.error('Do not set objects this way');
    }
    setPressure(value) {
        return this.dataService.updateAsset(this.id, { pressure: value }, this);
    }
    get pressure() {
        return this._pressure;
    }
    set waterPulseHot(value) {
        console.error('Do not set objects this way');
    }
    setWaterPulseHot(value) {
        return this.dataService.updateAsset(this.id, { water_pulse_hot: value }, this);
    }
    get waterPulseHot() {
        return this._waterPulseHot;
    }
    set temperature(value) {
        console.error('Do not set objects this way');
    }
    setTemperature(value) {
        return this.dataService.updateAsset(this.id, { temperature: value }, this);
    }
    get temperature() {
        return this._temperature;
    }
    set humidity(value) {
        console.error('Do not set objects this way');
    }
    setHumidity(value) {
        return this.dataService.updateAsset(this.id, { humidity: value }, this);
    }
    get humidity() {
        return this._humidity;
    }
    set light(value) {
        console.error('Do not set objects this way');
    }
    setLight(value) {
        return this.dataService.updateAsset(this.id, { light: value }, this);
    }
    get light() {
        return this._light;
    }
    set current(value) {
        console.error('Do not set objects this way');
    }
    setCurrent(value) {
        return this.dataService.updateAsset(this.id, { current: value }, this);
    }
    get current() {
        return this._current;
    }
    set occupancy(value) {
        console.error('Do not set objects this way');
    }
    setOccupancy(value) {
        return this.dataService.updateAsset(this.id, { occupancy: value }, this);
    }
    get occupancy() {
        return this._occupancy;
    }
    set assetSignalStrength(value) {
        console.error('Do not set objects this way');
    }
    setAssetSignalStrength(value) {
        return this.dataService.updateAsset(this.id, { asset_signal_strength: value }, this);
    }
    get assetSignalStrength() {
        return this._assetSignalStrength;
    }
    set assetBatteryVoltage(value) {
        console.error('Do not set objects this way');
    }
    setAssetBatteryVoltage(value) {
        return this.dataService.updateAsset(this.id, { asset_battery_voltage: value }, this);
    }
    get assetBatteryVoltage() {
        return this._assetBatteryVoltage;
    }
    set assetBatteryAlarm(value) {
        console.error('Do not set objects this way');
    }
    setAssetBatteryAlarm(value) {
        return this.dataService.updateAsset(this.id, { asset_battery_alarm: value }, this);
    }
    get assetBatteryAlarm() {
        return this._assetBatteryAlarm;
    }
    set assetBatteryPercent(value) {
        console.error('Do not set objects this way');
    }
    setAssetBatteryPercent(value) {
        return this.dataService.updateAsset(this.id, { asset_battery_percent: value }, this);
    }
    get assetBatteryPercent() {
        return this._assetBatteryPercent;
    }
    set firmwareTarget(value) {
        console.error('Do not set objects this way');
    }
    setFirmwareTarget(value) {
        return this.dataService.updateAsset(this.id, { firmware_target: value }, this);
    }
    get firmwareTarget() {
        return this._firmwareTarget;
    }
    set assetFirmwareVersion(value) {
        console.error('Do not set objects this way');
    }
    setAssetFirmwareVersion(value) {
        return this.dataService.updateAsset(this.id, { asset_firmware_version: value }, this);
    }
    get assetFirmwareVersion() {
        return this._assetFirmwareVersion;
    }
    set assetFirmwareProgress(value) {
        console.error('Do not set objects this way');
    }
    setAssetFirmwareProgress(value) {
        return this.dataService.updateAsset(this.id, { asset_firmware_progress: value }, this);
    }
    get assetFirmwareProgress() {
        return this._assetFirmwareProgress;
    }
    set demandPhaseOne(value) {
        console.error('Do not set objects this way');
    }
    setDemandPhaseOne(value) {
        return this.dataService.updateAsset(this.id, { demand_phase_one: value }, this);
    }
    get demandPhaseOne() {
        return this._demandPhaseOne;
    }
    set demandPhaseTwo(value) {
        console.error('Do not set objects this way');
    }
    setDemandPhaseTwo(value) {
        return this.dataService.updateAsset(this.id, { demand_phase_two: value }, this);
    }
    get demandPhaseTwo() {
        return this._demandPhaseTwo;
    }
    set demandPhaseThree(value) {
        console.error('Do not set objects this way');
    }
    setDemandPhaseThree(value) {
        return this.dataService.updateAsset(this.id, { demand_phase_three: value }, this);
    }
    get demandPhaseThree() {
        return this._demandPhaseThree;
    }
    set pfPhaseOne(value) {
        console.error('Do not set objects this way');
    }
    setPfPhaseOne(value) {
        return this.dataService.updateAsset(this.id, { pf_phase_one: value }, this);
    }
    get pfPhaseOne() {
        return this._pfPhaseOne;
    }
    set pfPhaseTwo(value) {
        console.error('Do not set objects this way');
    }
    setPfPhaseTwo(value) {
        return this.dataService.updateAsset(this.id, { pf_phase_two: value }, this);
    }
    get pfPhaseTwo() {
        return this._pfPhaseTwo;
    }
    set pfPhaseThree(value) {
        console.error('Do not set objects this way');
    }
    setPfPhaseThree(value) {
        return this.dataService.updateAsset(this.id, { pf_phase_three: value }, this);
    }
    get pfPhaseThree() {
        return this._pfPhaseThree;
    }
    set virtualLink(value) {
        console.error('Do not set objects this way');
    }
    setVirtualLink(value) {
        return this.dataService.updateAsset(this.id, { virtual_link: value }, this);
    }
    get virtualLink() {
        return this._virtualLink;
    }
    set doReconfigure(value) {
        console.error('Do not set objects this way');
    }
    setDoReconfigure(value) {
        return this.dataService.updateAsset(this.id, { do_reconfigure: value }, this);
    }
    get doReconfigure() {
        return this._doReconfigure;
    }
    set modbusId(value) {
        console.error('Do not set objects this way');
    }
    setModbusId(value) {
        return this.dataService.updateAsset(this.id, { modbus_id: value }, this);
    }
    get modbusId() {
        return this._modbusId;
    }
    set anomalyDetection(value) {
        console.error('Do not set objects this way');
    }
    setAnomalyDetection(value) {
        return this.dataService.updateAsset(this.id, { anomaly_detection: value }, this);
    }
    get anomalyDetection() {
        return this._anomalyDetection;
    }
    set lowBattery(value) {
        console.error('Do not set objects this way');
    }
    setLowBattery(value) {
        return this.dataService.updateAsset(this.id, { low_battery: value }, this);
    }
    get lowBattery() {
        return this._lowBattery;
    }
    set lowSignal(value) {
        console.error('Do not set objects this way');
    }
    setLowSignal(value) {
        return this.dataService.updateAsset(this.id, { low_signal: value }, this);
    }
    get lowSignal() {
        return this._lowSignal;
    }
    set fault(value) {
        console.error('Do not set objects this way');
    }
    setFault(value) {
        return this.dataService.updateAsset(this.id, { fault: value }, this);
    }
    get fault() {
        return this._fault;
    }
    set intermittent(value) {
        console.error('Do not set objects this way');
    }
    setIntermittent(value) {
        return this.dataService.updateAsset(this.id, { intermittent: value }, this);
    }
    get intermittent() {
        return this._intermittent;
    }
    set anomaly(value) {
        console.error('Do not set objects this way');
    }
    setAnomaly(value) {
        return this.dataService.updateAsset(this.id, { anomaly: value }, this);
    }
    get anomaly() {
        return this._anomaly;
    }
    set modbusDetails(value) {
        console.error('Do not set objects this way');
    }
    setModbusDetails(value) {
        return this.dataService.updateAsset(this.id, { modbus_details: value }, this);
    }
    get modbusDetails() {
        return this._modbusDetails;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateAsset(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteAsset(this.id, this);
    }
}
exports.default = Asset;
//# sourceMappingURL=asset.js.map